import UIFetchService from '../Service/UIFetchService';

import { Button, Col, Input, message, Modal, Popconfirm, Row, Table } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { } from '../Service/Utils';
import { isEmpty } from 'lodash';



function APIsView(props) {
    const [apis, setAPIs] = useState([]);
    const [newAccessTokenModalVisible, setNewAccessTokenModalVisible] = useState(false);
    useEffect(async () => {
        const rows = await UIFetchService.get('/api/v1/perm/apis');
        setAPIs(rows);
    }, []);

    const akLiteral = <code style={{ color: 'blue' }}>access_token</code>;
    return <>
        <Row justify='center'>
            <Col>
                <h4>API调用管理</h4>
            </Col>
        </Row>
        <Row>
            <Col>
                <span>
                    说明：生成API-
                    {akLiteral}
                    后，可以使用
                    {akLiteral}
                    访问数据平台的所有功能（需要先授权）
                    {akLiteral}需要和普通用户一样的授权，才能访问相应的功能
                </span>
            </Col>
        </Row>
        <Row>
            <Col>
                <span>
                    使用：在数据平台任意URL后面添加：<code>?access_token={'<生成的AK>'}</code>
                </span>
            </Col>
        </Row>
        <Row>
            <Col flex='100%'>
                <Table
                    dataSource={apis}
                    size='small'
                    bordered
                    rowKey='id'
                    pagination={false}
                    style={{ width: '100%' }}
                    footer={() => <Row justify='center'>
                        <Col>
                            <Button
                                type='link'
                                onClick={() => setNewAccessTokenModalVisible(true)}
                            >生成一条AK</Button>
                        </Col>
                    </Row>}
                >
                    <Table.Column
                        key='uid'
                        dataIndex='userId'
                        title='用户ID'
                    />
                    <Table.Column
                        key='appName'
                        dataIndex='appName'
                        title='应用名'
                    />
                    <Table.Column
                        key='createdAt'
                        dataIndex='createdAt'
                        title='生效时间'
                    />
                    <Table.Column
                        key='token'
                        dataIndex='token'
                        title='AccessToken'
                        render={token => <code>{token}</code>}
                    />
                    <Table.Column
                        key='comments'
                        dataIndex='comments'
                        title='备注'
                    />
                    <Table.Column
                        key='operators'
                        render={({ id }) => <Popconfirm
                            title='是否删除指定的AK?'
                            onConfirm={async () => {
                                await UIFetchService.delete(`/api/v1/perm/apis/${id}`);
                                const rows = await UIFetchService.get('/api/v1/perm/apis');
                                setAPIs(rows);
                            }}
                        >
                            <Button
                                icon={<DeleteOutlined />}
                                type='link'
                                danger
                                size='small'
                            />
                        </Popconfirm>}
                    />

                </Table>
            </Col>
        </Row>
        {newAccessTokenModalVisible && <NewAccessTokenModal
            visible={newAccessTokenModalVisible}
            onCancel={() => setNewAccessTokenModalVisible(false)}
            onOk={async (appName, comments) => {
                setNewAccessTokenModalVisible(false);
                await UIFetchService.post(`/api/v1/perm/apis`, { appName, comments });
                const rows = await UIFetchService.get('/api/v1/perm/apis');
                setAPIs(rows);
            }}
        />}
    </>
}

function NewAccessTokenModal(props) {
    const [appName, setAppName] = useState('');
    const [comments, setComments] = useState('');

    return <Modal
        {...props}
        title='新建API AccessToken'
        maskClosable={false}
        onOk={() => {
            if (isEmpty(appName)) {
                message.error('应用名不能为空');
                return;
            }
            props.onOk(appName, comments);
        }}
    >
        <Row>
            <Col flex='100px'>应用名</Col>
            <Col flex='auto'>
                <Input
                    value={appName}
                    onChange={({ target: { value } }) => setAppName(value)}
                    style={{ width: '100%' }}
                />
            </Col>
        </Row>
        <Row style={{ margin: '7px 0 0 0' }}>
            <Col flex='100px'>备注</Col>
            <Col flex='auto'>
                <Input.TextArea
                    rows={4}
                    value={comments}
                    onChange={({ target: { value } }) => setComments(value)}
                    style={{ width: '100%' }}
                />
            </Col>
        </Row>
    </Modal>
}

export default APIsView;